import { useAuthStore } from '../store/authStore';

export type UserRole = 'admin' | 'superadmin' | 'staff' | 'agent';

/**
 * Tenant-level role from the hydrated auth store (Wave 2.4 — no JS token to decode).
 * Falls back to 'agent' when unauthenticated / not yet hydrated.
 */
export function useRole(): UserRole {
  const role = useAuthStore((s) => s.role);
  return (role as UserRole) ?? 'agent';
}

export function useIsStaff(): boolean {
  const role = useRole();
  return role === 'staff' || role === 'admin' || role === 'superadmin';
}

export function useIsSuperAdmin(): boolean {
  // Checks the system-level user_role claim — NOT the tenant-level role.
  // Tenant owners (role: 'owner') must not be treated as system superadmins.
  const userRole = useAuthStore((s) => s.userRole);
  return userRole === 'superadmin';
}
